import { ICommonLabelsInStepper } from '../cms';

const organizeCommonLabelsInStepper = (cmsObj: ICommonLabelsInStepper) => ({
  openProductDetails: cmsObj?.commonlabels?.openProductDetails || '',
  closeProductDetails: cmsObj?.commonlabels?.closeProductDetails || '',
  goBackInStepper: cmsObj?.commonlabels?.goBackInStepper || '',
});

export { organizeCommonLabelsInStepper };
